import originalTerminologies from '../helper_functions/originalTerminologies';

export const getStatusDisplay = (status, business) => {
  const { checkedOutSingular, checkedInSingular } = originalTerminologies();

  switch (status) {
    case 'quote':
      return 'Quote';
    case 'reservation':
      return 'Reservation';
    case 'in_use':
      return business.softwareTier === 'all' ? checkedOutSingular : 'In Progress';
    case 'checked_in':
      return checkedInSingular;
    case 'closed':
      return 'Closed';
    case 'draft':
      return 'Draft';
    case 'cancelled':
      return 'Cancelled';
    case 'template':
      return 'Template';
    default:
      return null;
  }
};
